// Übungs- & Spielformen: Typen + Block-Vorauswahl.

export const FORM_TYPES = [
  { key: "aktivierung", label: "Aktivierung" },
  { key: "spielform", label: "Spielform" },
  { key: "technik", label: "Technik" },
  { key: "abschluss", label: "Abschluss" },
];

export const FORM_TYPE_LABEL = Object.fromEntries(
  FORM_TYPES.map((t) => [t.key, t.label]),
);

// Farb-Akzent je Typ (badge), am Marken-/Modul-Design orientiert.
export const FORM_TYPE_ACCENT = {
  aktivierung: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  spielform: "bg-brand/15 text-brand-lighter border-brand/30",
  technik: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  abschluss: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
};

// Welcher Form-Typ wird beim Öffnen von "Aus Bibliothek" je Block priorisiert?
export const BLOCK_DEFAULT_FORM_TYPE = {
  aktivierung: "aktivierung",
  spielform_1: "spielform",
  zwischenblock: "technik",
  spielform_2: "spielform",
};
